export enum Host {
  QA = "qa.whatsapp.turn.io",
  PROD = "whatsapp.turn.io",
}
